module.exports = __webpack_public_path__ + "img/exporo_logo.117afe6f.svg";